import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "mediaQuery", "direction"];
var __jsx = React.createElement;
import React, { useState, useEffect, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
var MediaQuery = /*#__PURE__*/forwardRef(function (props, ref) {
  var theme = useTheme();

  // eslint-disable-next-line prefer-const
  var as = props.as,
    _props$mediaQuery = props.mediaQuery,
    mediaQuery = _props$mediaQuery === void 0 ? "sm" : _props$mediaQuery,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'up' : _props$direction,
    otherProps = _objectWithoutProperties(props, _excluded);
  var goodMQ = mediaQuery;
  if (mediaQuery.length < 4) {
    goodMQ = theme.breakpoints[direction](mediaQuery);
  }
  var doesMatch = useMediaQuery(goodMQ);
  var _useState = useState(false),
    shouldUseMediaQuery = _useState[0],
    setShouldUseMediaQuery = _useState[1];
  useEffect(function () {
    setShouldUseMediaQuery(true);
  }, []);
  if (shouldUseMediaQuery && !doesMatch) {
    return null;
  }

  // div inside button is not valid HTML
  // provide option to render span for a11y purposes
  if (as === 'span') {
    return __jsx(ContentSpan, _extends({
      ref: ref,
      mediaQuery: goodMQ
    }, otherProps));
  }
  return __jsx(ContentDiv, _extends({
    ref: ref,
    mediaQuery: goodMQ
  }, otherProps));
});
MediaQuery.snapshot = false;
var contentStyles = css(["display:none;", "{display:", ";}"], function (_ref) {
  var mediaQuery = _ref.mediaQuery;
  return mediaQuery;
}, function (_ref2) {
  var _ref2$display = _ref2.display,
    display = _ref2$display === void 0 ? 'inherit' : _ref2$display;
  return display;
});
var ContentDiv = styled.div.withConfig({
  displayName: "media-query__ContentDiv",
  componentId: "sc-18mweoi-0"
})(["", ""], contentStyles);
var ContentSpan = styled.span.withConfig({
  displayName: "media-query__ContentSpan",
  componentId: "sc-18mweoi-1"
})(["", ""], contentStyles);
export default MediaQuery;